module.exports = require('./container_factory')



// WEBPACK FOOTER //
// ./src/components/container_factory/index.js